import React, {Component} from 'react'
import {Row, Col} from 'antd'

import 'styles/footer.css'

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <Row>
          <Col className="item" span={6}>
            <a href="#/homePage">
              <img src="images/service/4_62.jpg" alt="购物"/>
              <p>购物</p>
            </a>
          </Col>
          <Col className="item" span={6}>
            <a href="#/service">
              <img src="images/service/4.0_62.jpg" alt="服务"/>
              <p>服务</p>
            </a>
          </Col>
          <Col className="item" span={6}>
            <a href="">
              <img src="images/service/4_68.jpg" alt="社交"/>
              <p>社交</p>
            </a>
          </Col>
          <Col className="item" span={6}>
            <a href="">
              <img src="images/service/4.0_68.jpg" alt="我的"/>
              <p>我的</p>
            </a>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js